import {QTableColumn} from "pansx-utils/src/index";

export class UserInfoEntity {
    public userName?: string;
    public userType?: string;
    public userIdentity?: string;
    public companyCreditCode?: string;
    public companyId!: string;
    public companyName?: string;
    public companyNameIdentity?: string;
    public companyStatus?: string;
    public userId?: string;


    public static of(o: unknown): UserInfoEntity {
        return Object.assign(new UserInfoEntity(), o);
    }

    public static getColumns(): QTableColumn[] {
        return [
            {name: 'userName', field: 'userName', label: '用户名字'},
            {name: 'userType', field: 'userType', label: '用户类型'},
            {name: 'userIdentity', field: 'userIdentity', label: '用户身份'},


        ];
    }

    public getColumnLabel(field: string) {
        const columns = UserInfoEntity.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field,
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
